/**
 * AA-safe TEXT variants of the 8 brand player colors (audit 2026-06-11).
 *
 * The raw palette is tuned for canvas strokes and avatar fills; as 13px TEXT
 * on --paper (#fdf6e3) several entries fail WCAG AA badly (yellow ≈1.3:1,
 * green ≈2.3:1, orange ≈2.4:1, purple ≈4.2:1). This map darkens each hue just
 * enough to clear 4.5:1 while still reading as "that player's color". Fills
 * (player dots, swatches, strokes) keep using the raw palette.
 *
 * Pinned by textSafeColor.test.ts, which computes the actual contrast ratio
 * of every entry against --paper.
 */
const TEXT_SAFE_BY_HEX: Record<string, string> = {
  "#000000": "#1a1a1a", // black → --ink
  "#e63946": "#c1121f", // red → --urgent-ink
  "#ffd23f": "#7a6000", // yellow → dark mustard
  "#4361ee": "#4361ee", // blue, already ≈4.65:1
  "#7cb518": "#4f7a0e", // green → --correct-ink
  "#8b5a2b": "#8b5a2b", // brown, already ≈5.3:1
  "#f77f00": "#c2410c", // orange → --orange (burnt)
  "#9d4edd": "#8634c6", // purple → deepened
};

/** Text-safe variant of a player color; unknown hexes fall back to themselves. */
export function textSafeColor(hex: string): string {
  return TEXT_SAFE_BY_HEX[hex.toLowerCase()] ?? hex;
}
